import { useCallback } from 'react';
import { useUpdateConversion } from './useUpdateConversion';

export const useHandleButtonAnalyzerClick = ({ goNext, setIsHighlighting, currentIndex }) => {
    const updateConversion = useUpdateConversion();

    return useCallback(
        buttonData => {
            setIsHighlighting(false);
            updateConversion({ buttonData, currentIndex });
            goNext();
        },
        [currentIndex, goNext, setIsHighlighting, updateConversion]
    );
};
